import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const mockData = [
  { name: 'New', value: 234, color: 'hsl(var(--chart-1))' },
  { name: 'Contact Attempt', value: 156, color: 'hsl(var(--chart-2))' },
  { name: 'In Negotiation', value: 89, color: 'hsl(var(--chart-3))' },
  { name: 'Payment Plan', value: 67, color: 'hsl(var(--chart-4))' },
  { name: 'Legal', value: 43, color: 'hsl(var(--chart-5))' },
  { name: 'Settled', value: 178, color: 'hsl(var(--primary))' },
];

export function CaseStatusChart() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Case Distribution</CardTitle>
        <CardDescription>Current cases by workflow stage</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={mockData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {mockData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
